import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { VoterDataBuildScreen, parseSavedList } from '@/components/work-orders';
import type { SavedList } from '@/components/work-orders';

/**
 * The Voter data builder. Guarded by the parent {@link /app/work-orders} layout (platform admin
 * or full admin). Like all of Work Orders it is outside the paywall, so a campaign whose trial has
 * lapsed can still build and buy a list (ADR-090). Building needs no `workOrdersEnabled`; ordering
 * does, and the builder says so when it's off (ADR-096).
 */
export const Route = createFileRoute('/app/work-orders/voter-data')({
  validateSearch: (search: Record<string, unknown>): { list?: SavedList } => ({ list: parseSavedList(search.list) }),
  component: VoterDataRoute,
});

function VoterDataRoute() {
  const saved = Route.useSearch({ select: (search) => search.list });
  const navigate = Route.useNavigate();
  // Each change replaces the entry, so Back leaves the builder rather than undoing a rule.
  const onSave = useCallback((list: SavedList | undefined) => void navigate({ search: { list }, replace: true }), [navigate]);
  return <VoterDataBuildScreen saved={saved} onSave={onSave} />;
}
